import { Workflow, NormalizedWorkflowType } from './types';

export const exportWorkflowsToCSV = (
  workflows: Workflow[],
  filename: string,
  workflowTypes: NormalizedWorkflowType[] = []
) => {
  if (workflows.length === 0) {
    alert('No data to export');
    return;
  }

  // Define CSV headers
  const headers = [
    'ID',
    'Type',
    'Servicer Account ID',
    'Case Number',
    'Assigned Date',
    'Assigned To',
    'Assigned To Name',
  ];

  // Convert workflows to CSV rows
  const csvRows = workflows.map((workflow) => [
    workflow.id,
    `"${workflowTypes.find((wt) => wt.value === (workflow.requestType || ''))?.label || workflow.requestType || ''}"`,
    workflow.accountId,
    workflow.caseNumber || '',
    new Date(workflow.assignedDate).toLocaleDateString(),
    workflow.assignedTo || '',
    `"${workflow.assignedToName || ''}"`, // Wrap in quotes to handle commas
  ]);

  // Combine headers and rows
  const csvContent = [
    headers.join(','),
    ...csvRows.map((row) => row.join(',')),
  ].join('\n');

  // Create and download the file
  const blob = new Blob([csvContent], { type: 'text/csv;charset=utf-8;' });
  const link = document.createElement('a');

  if (link.download !== undefined) {
    const url = URL.createObjectURL(blob);
    link.setAttribute('href', url);
    link.setAttribute('download', filename);
    link.style.visibility = 'hidden';
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
    URL.revokeObjectURL(url);
  }
};

export const generateCSVFilename = (tableType: 'my' | 'company'): string => {
  const now = new Date();
  const timestamp = now.toISOString().split('T')[0]; // YYYY-MM-DD format
  const type = tableType === 'my' ? 'My_Workflows' : 'Company_Workflows';
  return `${type}_${timestamp}.csv`;
};
